import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Flex } from 'antd';
import SetupPackage from './SetupPackage';
import { BillingMode } from '../../services/exports/Constants';
import useHelpers from '../../hooks/context/useHelpers';
import { computeStripeBillingDiscount } from '../../services/helpers/PricingHelpers';

export default function PriceInfo({
  data,
  setupPackages,
  onChange,
  onSetupPackageSelection,
  discount = 0,
  loading,
  className,
  children,
}) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Contract:PriceInfo' });

  const { formatCurrency } = useHelpers();

  const stripeBillingDiscount = useMemo(() => computeStripeBillingDiscount(setupPackages), [setupPackages]);

  return (
    <div className={className}>
      <h2 className="text-center mt-lg">
        <Trans
          t={t}
          components={{
            underline: <span className="underline" />,
          }}
        >
          title
        </Trans>
      </h2>
      <Flex justify="center" className="mt-md">
        <Flex className="border border-solid border-brand-primary p-xs rounded-3xl">
          <Button
            color="default"
            variant={data.billing_mode === BillingMode.InternalInvoicing ? 'solid' : 'text'}
            className="rounded-3xl text-md transition-colors duration-200"
            onClick={() => onChange('billing_mode', BillingMode.InternalInvoicing)}
          >
            {t(`billing_modes.${BillingMode.InternalInvoicing}`)}
          </Button>
          <Button
            color="default"
            variant={data.billing_mode === BillingMode.Stripe ? 'solid' : 'text'}
            className="rounded-3xl text-md transition-colors duration-200"
            onClick={() => onChange('billing_mode', BillingMode.Stripe)}
          >
            {t(`billing_modes.${BillingMode.Stripe}`, {
              postProcess: 'interval',
              count: stripeBillingDiscount,
              discount: formatCurrency(stripeBillingDiscount),
            })}
          </Button>
        </Flex>
      </Flex>
      <div className="mt-lg grid grid-cols-3 gap-md">
        {setupPackages.map((item) => (
          <SetupPackage
            data={item}
            billingMode={data.billing_mode}
            discount={discount}
            loading={loading && data.setup_package_id === item.id}
            onSelect={() => onSetupPackageSelection(item)}
            key={`setup-package-${item.id}`}
          />
        ))}
      </div>
      {children}
    </div>
  );
}
